import { combineReducers } from 'redux';

import basket from '@store/basket/reducers';
import entities from '@store/entity/reducers';
import fetching from '@store/fetching/reducers';
import filtered from '@store/filtered/reducers';
import guest from '@store/guest/reducers';
import guestPickerValidation from '@store/guestPickerValidation/reducers';
import modalError from '@store/modalError/reducers';
import order from '@store/order/reducers';
import pagination from '@store/pagination/reducers';
import rates from '@store/rates/reducers';
import rooms from '@store/rooms/reducers';
import setting from '@store/setting/reducers';
import table from '@store/table/reducers';
import yourJourney from '@store/yourJourney/reducers';
import { reducers as deferredPayments } from './deferredPayments';
import { reducers as tracking } from './tracking/reducers';

export default combineReducers({
  entities,
  filtered,
  setting,
  fetching,
  basket,
  guest,
  rates,
  rooms,
  order,
  table,
  yourJourney,
  modalError,
  guestPickerValidation,
  pagination,
  tracking,
  deferredPayments,
});
